// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"733030f7","41":"92c69b88","145":"d9d55f88","372":"cab053b6","390":"f51d51a6","405":"f252c934","615":"511b2748","818":"93e74e57","830":"c68eb72e","898":"ecdb7730","953":"e3739efc"}[chunkId] + ".chunk.js";
};